import { createSelector } from 'reselect';
import { getTr } from '../../../ReportByReferral/ReportByReferral.selectors';
import ReportByReferralComponent from '../../../../utils/ReportByReferralComponent/ReportByReferralComponent';
import resolveMetricsConfig from '../../../../helpers/reportMetrics';
import store from '../../../../stores/redux';

const reportUtils = ReportByReferralComponent.utils;

const rows = (state) => state.statistics.data.rows;
const totals = (state) => state.statistics.data.totals;
const parameters = (state) => state.statistics.data.parameters;
const location = (state) => state.routing?.location || state.routing?.locationBeforeTransitions || {};
const offers = (state) => state.offers.list;
const goals = (state) => state.goals.list;
const links = (state) => state.links.list;
const regions = (state) => state.regions.list;
const reportByReferral = (state) => state.serverStorage.store.reportByReferral || state.serverStorage.store.report;
let oldRows = rows(store.getState());

export const mainSelector = createSelector(
    rows,
    totals,
    parameters,
    location,
    reportByReferral,
    offers,
    goals,
    links,
    regions,
    (rows = [], totals = {}, parameters = {}, location = {}, reportByReferral = {}, offers = [], goals = [], links = [], regions = []) => {
        let data = '';

        const metricsConfig = resolveMetricsConfig(parameters, location, reportByReferral && reportByReferral.metrics, reportUtils);
        const newParameters = {
            ...parameters,
            isChange: oldRows !== rows,
            isHtml: false,
            metricsBinary: metricsConfig.binary
        };
        
        oldRows = rows;

        rows.map((item) => {
            data += getTr(item, newParameters);
        });

        if (Object.keys(totals).length) {
            data += getTr(totals, newParameters, true);
        }

        return data;
    }
);

export const getHeaderName = createSelector(
    parameters,
    location,
    reportByReferral,
    (parameters = {}, location = {}, reportByReferral = {}) => {
        reportUtils.setKeyGroupBy(parameters.group_by || (location.query && location.query.groupBy));
        let headerNames = reportUtils.getMultiLevelHeaderNames();
        const metricsConfig = resolveMetricsConfig(parameters, location, reportByReferral && reportByReferral.metrics, reportUtils);
        let visibleKeysMetric = metricsConfig.keys;

        reportUtils.updateVisible(headerNames, visibleKeysMetric);

        return headerNames;
    }
);

export const getMetrics = createSelector(
    parameters,
    location,
    reportByReferral,
    (parameters = {}, location = {}, reportByReferral = {}) => {
        return resolveMetricsConfig(parameters, location, reportByReferral && reportByReferral.metrics, reportUtils).binary;
    }
);

export const getKeysMetric = createSelector(
    parameters,
    location,
    reportByReferral,
    (parameters = {}, location = {}, reportByReferral = {}) => {
        return resolveMetricsConfig(parameters, location, reportByReferral && reportByReferral.metrics, reportUtils).keys;
    }
);
